import Vue from "vue";
import Vuex from "vuex";

// *** Modules
import userStore from "./userStore";
import workoutStore from "./workoutStore";
import historyStore from "./historyStore";
import templateStore from "./templateStore";
import exerciseStore from "./exerciseStore";

// *** Interfaces
import { getNowInUnix } from "@/interfaces/time.interface";
import { userData } from "@/interfaces/user.interface";
import { Workout } from "@/interfaces/workout.interface";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    userStore: {
      namespaced: true,
      state: userStore.state,
      getters: userStore.getters,
      mutations: userStore.mutations,
      actions: userStore.actions,
    },
    workoutStore: {
      namespaced: true,
      state: workoutStore.state,
      getters: workoutStore.getters,
      mutations: workoutStore.mutations,
      actions: workoutStore.actions,
    },
    historyStore: {
      namespaced: true,
      state: historyStore.state,
      getters: historyStore.getters,
      mutations: historyStore.mutations,
      actions: historyStore.actions,
    },
    templateStore: {
      namespaced: true,
      state: templateStore.state,
      getters: templateStore.getters,
      mutations: templateStore.mutations,
      actions: templateStore.actions,
    },
    exerciseStore: {
      namespaced: true,
      state: exerciseStore.state,
      getters: exerciseStore.getters,
      mutations: exerciseStore.mutations,
      actions: exerciseStore.actions,
    },
  },
});

store.subscribe((mutation, state) => {
  if (mutation.type.startsWith("historyStore")) {
    localStorage.setItem(
      "workoutHistory",
      JSON.stringify(state.historyStore.workoutHistory)
    );
    localStorage.setItem("workoutHistoryUpdate", String(getNowInUnix()));
  }

  if (mutation.type.startsWith("workoutStore")) {
    const currentUserData: userData | null = state.userStore.userData;
    const currentStoreWorkout: Workout | null =
      state.workoutStore.currentWorkout;

    if (currentUserData) {
      currentUserData.currentWorkout = currentStoreWorkout;
      localStorage.setItem("userData", JSON.stringify(currentUserData));
      localStorage.setItem("userDataLastUpdate", String(getNowInUnix()));
    }
  }

  // Todo: whenever a user creates a new exercise, add it to store
  // if (mutation.type.startsWith("exerciseStore")) {
  // }
});

export default store;
